import { render, staticRenderFns } from "./uploadDialog.vue?vue&type=template&id=2208aebc&scoped=true"
import script from "./uploadDialog.vue?vue&type=script&lang=js"
export * from "./uploadDialog.vue?vue&type=script&lang=js"
import style0 from "./uploadDialog.vue?vue&type=style&index=0&id=2208aebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208aebc",
  null
  
)

export default component.exports